module.exports = __webpack_public_path__ + "img/detailsaee10.6fc2deff.svg";